// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';


function deepMerge(json1, json2) {
  var match_0 = json1 === null;
  var match_1 = Array.isArray(json1);
  var match_2 = typeof json1 === "object";
  var match_0$1 = json2 === null;
  var match_1$1 = Array.isArray(json2);
  var match_2$1 = typeof json2 === "object";
  if (match_1) {
    if (match_1$1) {
      return json1.map(function (el1, idx) {
                  var el2 = json2[idx];
                  if (typeof el2 === "object") {
                    return deepMerge(el1, el2);
                  } else {
                    return el2;
                  }
                });
    } else {
      return json2;
    }
  }
  if (match_0) {
    return json2;
  }
  if (!match_2) {
    return json2;
  }
  if (match_0$1) {
    return json2;
  }
  if (match_1$1) {
    return json2;
  }
  if (!match_2$1) {
    return json2;
  }
  var obj1 = Object.assign({}, json1);
  Object.keys(json2).forEach(function (key) {
        var existingVal = obj1[key];
        var newVal = json2[key];
        obj1[key] = typeof existingVal !== "object" ? newVal : deepMerge(existingVal, newVal);
        
      });
  return obj1;
}

exports.deepMerge = deepMerge;
/* No side effect */
